import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { TZDate } from '@date-fns/tz';

// Конвертация сырых date/time слота (в таймзоне преподавателя) в таймзону зрителя.
// date — "2026-09-23" (ISO) или "23.09.2026", time — "18:00".
// Возвращает null, если не хватает данных для конвертации.
export const convertSlotDateTime = (date, time, fromTimezone, toTimezone) => {
  if (!date || !time || !fromTimezone || !toTimezone) return null;
  try {
    const dateParts = String(date).split(/[./-]/).map(Number);
    if (dateParts.length !== 3 || dateParts.some(Number.isNaN)) return null;
    const [a, b, c] = dateParts;
    const [year, month, day] = a > 31 ? [a, b, c] : [c, b, a];

    const timeParts = String(time).split(':').map(Number);
    if (timeParts.length < 2 || timeParts.some(Number.isNaN)) return null;
    const [hours, minutes] = timeParts;

    // Локальное время преподавателя как момент на шкале времени
    const teacherLocal = new TZDate(year, month - 1, day, hours, minutes, 0, fromTimezone);
    // Тот же момент в таймзоне зрителя
    const viewer = new TZDate(teacherLocal, toTimezone);

    return {
      date: format(viewer, 'dd.MM.yyyy'),
      time: format(viewer, 'HH:mm'),
      label: format(viewer, 'd MMMM yyyy, HH:mm', { locale: ru }),
    };
  } catch {
    return null;
  }
};
